import styled from '@emotion/styled';

export const IllustrationContainer = styled.div`
  margin-bottom: 46px;
`;
